export default __webpack_public_path__ + "bfe7918.png";